import React from 'react';
import { shape, string } from 'prop-types';
import { Redirect, Switch, withRouter } from 'react-router-dom';

import queryString from 'query-string';

import RulesPage from './RulesPage';
import RuleDebuggerPage from './RuleDebuggerPage';
import RuleTargetsPage from './RuleTargetsPage';
import ModifyRulePage from './ModifyRulePage';
import ProtectedRoute from '../../components/ProtectedRoute';

import classes from './Rules.module.css';

const getCompanySearch = location => {
    const queryValues = queryString.parse(location.search);
    return '?company=' + queryValues.company;
};

const Rules = ({ location }) => (
    <div className={classes.root}>
        <Switch>
            <ProtectedRoute
                component={ModifyRulePage}
                path="/rules/:id/edit/:tab"
                permissions="rulesRead"
            />
            <ProtectedRoute
                component={RuleDebuggerPage}
                path="/rules/:id/exceptions"
                permissions="rulesRead"
            />
            <ProtectedRoute
                component={RuleTargetsPage}
                path="/rules/:id/targets"
                permissions="rulesRead"
            />
            <Redirect
                from="/rules/:id/edit"
                to={{
                    pathname: '/rules/:id/edit/properties',
                    search:   location.search
                }}
            />
            <ProtectedRoute
                component={ModifyRulePage}
                path="/rules/new/:tab"
                permissions="rulesFull"
            />
            <Redirect
                from="/rules/new"
                to={{
                    pathname: '/rules/new/properties',
                    search:   getCompanySearch(location)
                }}
            />
            <ProtectedRoute
                component={RulesPage}
                path="/rules"
                permissions="rulesRead"
            />
        </Switch>
    </div>
);

Rules.propTypes = {
    location: shape({
        search: string
    }).isRequired
};

export default withRouter(Rules);
